import React from 'react';
import { DatePicker as MuiDatePicker, DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

export interface DatePickerProps extends Omit<MuiDatePickerProps, 'value' | 'onChange'> {
  value: Dayjs | string | null;
  onChange: (value: Dayjs | null) => void;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

export const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  fullWidth = true,
  size = 'small',
  ...rest
}) => {
  const parsedValue = typeof value === 'string' ? dayjs(value) : value;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        value={parsedValue}
        onChange={onChange}
        slotProps={{
          textField: {
            fullWidth,
            size,
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
